export const PERMISSION_GROUP_NAME = [
    {key:'transaction',name:'Lịch Sử Giao Dịch'},
    {key:'receipt',name:'Phiếu Thu'},
    {key:'payment',name:'Phiếu Chi'},
    {key:'privilege',name:'Vai Trò Tài Khoản Quỹ'},
    {key:'message',name:'Tin Nhắn'},
    {key:'account',name:'Tài Khoản Quỹ'},
    {key:'sub',name: 'Giao Dịch Con'}
]
